import React from 'react';

export default function CuisineSkeleton() {
  return (
    <div className="w-full min-h-[35rem] animate-pulse p-4 flex flex-col md:flex-row gap-8 bg-gray-50 items-center">
      <div className="w-full md:w-1/2 aspect-[4/5] bg-gray-200 rounded" />
      <div className="w-full md:w-1/2 flex flex-col gap-4 mt-8 md:mt-0 p-8">
        <div className="h-16 bg-gray-200 w-3/4 rounded" />
        <div className="h-6 bg-gray-200 w-full rounded" />
        <div className="h-6 bg-gray-200 w-5/6 rounded" />
        <div className="h-6 bg-gray-200 w-4/6 rounded" />
      </div>
    </div>
  );
}
